import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
};

export const meGetNotificationsSettings = createQueryFn(
  QueryNameSpace.meGetNotificationsSettings,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const data = await DigiobcanApi.meGetNotificationsSettings(params);

    return data;
  },
);
